import { Section } from "@/components/ds/Section/Section";
import { Container } from "@/components/ds/Container/Container";
import { Stack } from "@/components/ds/Stack/Stack";
import { Heading } from "@/components/ds/Heading/Heading";
import { Text } from "@/components/ds/Text/Text";
import { Button } from "@/components/ds/Button/Button";
import { Reveal } from "@/components/ds/Reveal/Reveal";
import { AlertCircleIcon } from "@/icons/AlertCircleIcon";
import { ShieldIcon } from "@/icons/ShieldIcon";
import { CreditCardIcon } from "@/icons/CreditCardIcon";
import styles from "./ClosedLoop.module.css";

const OUTCOMES = [
  {
    icon: AlertCircleIcon,
    title: "Fewer surprise calls",
    description:
      "Missed check-ins surface on your dashboard before the client picks up the phone.",
  },
  {
    icon: ShieldIcon,
    title: "Proof on tap",
    description:
      "GPS-verified check-in and check-out for every visit, filterable by date, site, or cleaner.",
  },
  {
    icon: CreditCardIcon,
    title: "Hours you can trust",
    description:
      "Entry and exit times on every shift, so invoicing matches what actually happened.",
  },
] as const;

export function ClosedLoop() {
  return (
    <Section background="emerald-dark">
      <Container>
        <Reveal>
          <Stack gap={10} align="center">
            <Stack gap={4} align="center">
              <Heading level={2} size="h2" color="on-dark">
                The whole operation, in full view.
              </Heading>
              <Text size="lg" color="on-dark-muted" className={styles.subtitle}>
                Every rota, every check-in, every minute logged. Nothing
                happens in your cleaning business that you can&apos;t see.
              </Text>
            </Stack>

            <div className={styles.outcomes}>
              {OUTCOMES.map((outcome) => (
                <div key={outcome.title} className={styles.outcome}>
                  <outcome.icon width={28} height={28} className={styles.outcomeIcon} />
                  <Text as="span" weight="bold" color="on-dark">
                    {outcome.title}
                  </Text>
                  <Text size="sm" color="on-dark-muted">
                    {outcome.description}
                  </Text>
                </div>
              ))}
            </div>

            <Button href="#get-started" variant="accent" size="lg">
              See it in action
            </Button>
          </Stack>
        </Reveal>
      </Container>
    </Section>
  );
}
